<script lang="ts" setup>
import { inject } from 'vue';
import { CONTEXT_KEY } from './types';

defineOptions({
  name: 'CarouselContext',
});

const context = inject(CONTEXT_KEY);
</script>

<template>
  <slot
    :page="context?.currentPage.value ?? 0"
    :pages="context?.pages.value ?? []"
  >
  </slot>
</template>

<style lang="scss" scoped>
</style>
